import { useState } from 'react'
import Image from 'next/legacy/image'
import { useTranslation } from 'next-i18next'

import { Button } from '@/components/button-new'
import SwitchToggle from '@/components/form/switch-toggle'
import { createModal } from '@/components/modalize'

import {
  BlinkingDot,
  ImageWrapper,
  ModalContent,
  ModalRow,
  ModalTopper,
  Subtitle,
  Title,
  ToggleLabel,
  Wrapper
} from '../styles/interactive-modal.styles'
import InteractiveHide from '../images/interactive_hide.png'
import InteractiveShow from '../images/interactive_show.png'

interface Button {
  text: string
  id: string
  onClick: () => void
}
interface Props {
  message?: string
  messages?: string[]
  showIcon?: boolean
  button?: Button
  content?: JSX.Element
}

const InteractiveModal: React.FC<Props> = () => {
  const { t } = useTranslation()
  const [showUnit, setShowUnit] = useState(false)

  return (
    <Wrapper>
      <ModalTopper>
        <ImageWrapper>
          <Image
            src={showUnit ? InteractiveHide : InteractiveShow}
            alt={showUnit ? 'Hide unit number' : 'Show unit number'}
          />
        </ImageWrapper>
        <ModalRow>
          {!showUnit && <BlinkingDot />}
          <SwitchToggle
            onChange={() => setShowUnit(!showUnit)}
            enabled={showUnit}
          />
          <ToggleLabel
            htmlFor="hide_unit_number"
            strong
            id="unit-number-label"
            left
          >
            {t(
              'l.listing.create.hide_unit_number_interactive.label',
              'Hide unit number from listing'
            )}
          </ToggleLabel>
        </ModalRow>
      </ModalTopper>
      <ModalContent>
        <Title>
          {t(
            'l.post_a_listing.interactive.modal.title',
            'Protect your privacy'
          )}
        </Title>
        <Subtitle>
          {t(
            'l.post_a_listing.interactive.modal.text',
            'Turn on to hide the unit number for apartment listings, or the street number and precise location for house listings. Click the toggle above to give it a try!'
          )}
        </Subtitle>
      </ModalContent>
    </Wrapper>
  )
}

export const show = createModal(InteractiveModal, {
  width: '100%',
  maxWidth: '600px'
})
